// Import jQuery and expose it globally FIRST
import jQuery from 'jquery';
window.$ = jQuery;
window.jQuery = jQuery;

// Force jQuery to be available before loading plugins
const $ = jQuery;

// Now import jQuery plugins - using require to ensure jQuery is set first
require('bootstrap/dist/js/bootstrap.bundle.js');
require('jquery.easing');

// Import WOW.js from our fixed version that properly exports
const WOW = require('./wow-fixed.js');
window.WOW = WOW;

require('slick-carousel/slick/slick.js');
require('material-scrolltop/dist/material-scrolltop.js');
require('waypoints/lib/jquery.waypoints.js');

// Import custom modules
require('./counter.js');
require('./contenttoggle_mk.js');
require('./scripts.js');
